import { ReactElement } from "react";
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from "@mui/material";
import { FieldRenderProps } from "react-final-form";

interface CheckboxControlSimpleProps {
  label?: string | ReactElement;
}

const CheckboxControlSimple = ({
  input: { name, onChange, checked },
  meta,
  label,
}: FieldRenderProps<any> & CheckboxControlSimpleProps) => {
  return (
    <FormControl error variant="standard">
      <FormControlLabel
        style={{ alignItems: "start" }}
        control={
          <Checkbox
            sx={{ color: "text.primary", padding: "0 12px" }}
            required={false}
            name={name}
            checked={checked}
            onChange={(e, checked) => {
              console.log(e);
              onChange(checked);
            }}
          />
        }
        label={label ?? ""}
      />
      {meta.touched && (meta.error || meta.submitError) && (
        <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxControlSimple;
